<template>
  <div v-if="!isExpired" class="tabel">
    <!-- 搜索 -->
    <div ref="topDom" class="header-bar">
      <div class="bar-lef">
        <div class="lef-group">
          <div class="group-one">
            <a-date-picker v-model:value="searchForm.start_date" placeholder="起始日期" @change="changeStartDate" />
          </div>
          <div class="group-one">
            <a-select v-model:value="searchForm.store_id" :allowClear="true" mode="default" placeholder="门店" style="width: 150px" @change="init">
              <a-select-option v-for="item in searchList.store?.list" :key="item.id" :value="item.id">{{ item.name }} </a-select-option>
            </a-select>
          </div>
          <div class="group-one">
            <a-select v-model:value="searchForm.rids" :allowClear="true" :filterOption="optionFilter" :maxTagCount="1" mode="multiple" placeholder="房型" style="width: 150px" @change="init">
              <a-select-option v-for="item in searchList.room?.list" :key="item.id" :value="item.id">{{ item.name }} </a-select-option>
            </a-select>
          </div>
          <div class="group-one">
            <a-select v-model:value="searchForm.gids" :allowClear="true" :filterOption="optionFilter" :maxTagCount="1" mode="multiple" placeholder="分组" style="width: 150px" @change="init">
              <a-select-option v-for="item in searchList.group?.list" :key="item.id" :value="item.id">{{ item.name }} </a-select-option>
            </a-select>
          </div>
          <div class="group-one">
            <a-select v-model:value="searchForm.type" allowClear placeholder="订单类型" @change="init">
              <a-select-option v-for="item in searchList.orderType?.list" :key="item.id" :value="item.id">{{ item.name }} </a-select-option>
            </a-select>
          </div>
        </div>
        <div class="lef-one">
          <a-input-search :loading="searchLoading" placeholder="房号\单号\客人\手机\备注" style="width: 250px" @search="search"> </a-input-search>
        </div>
        <div v-if="searchingId.length > 1" class="search-tip">
          共找到<span style="color: #da0000">{{ searchingIndex + 1 }}/{{ searchingId.length }}</span
          >条数据，
          <span class="search-last" @click="searchLast">上一条</span>
          <span class="search-next" @click="searchNext">下一条</span>
        </div>
      </div>
    </div>

    <!-- 表格 -->
    <div class="tables">
      <!-- 左 -->
      <div class="table-left">
        <!-- 左上 -->
        <div class="left-top">
          <div class="top-box">
            <!-- <a-date-picker v-model:value="value1" /> -->
            {{ dayjs(start_date).format('MM-DD') }}~{{ dayjs(start_date).add(20, 'day').format('MM-DD') }}
          </div>
        </div>
        <!-- 左下 -->
        <div
          :style="{
            height: tableHeight - 112 + 'px',
            paddingBottom: scrollbarWidth + 'px',
          }"
          class="left-bom scroll1"
        >
          <div id="left-bom">
            <div v-for="(item, index) in conditionData.menu" :id="'h-' + item.hid" :key="index" :class="{ isHouse: item.type == 1 }" class="bom-box">
              <div v-if="item.type == 1 && item.is_show !== 2" class="box-date">
                {{ item.rname }}
              </div>
              <div v-else class="box-date">{{ item.hname }}</div>
            </div>
            <div style="height: 50px"></div>
          </div>
        </div>
      </div>
      <!-- 右 -->
      <div :style="{ height: tableHeight - 90 + 'px' }" class="table-right">
        <!-- 右上 -->
        <div
          :style="{
            width: tableWidth - 170 + 'px',
            paddingRight: scrollbarWidth + 'px',
          }"
          class="top-box scroll2"
        >
          <div class="top-row">
            <div v-for="(item, index) in headList" :key="index" class="box-grid">
              <div :id="'d-' + item.date" class="grid-box">
                <div v-if="isToday(item.time)" class="today">今天</div>
                <div v-else :class="{ weekend: item.week == '五' || item.week == '六' }" class="date">
                  {{ item.date.substring(item.date.length - 5) }}
                  <span v-if="item.holidaytag" class="holiday">{{ item.holidaytag }}</span>
                  <span v-else style="margin-left: 2px">{{ item.week }}</span>
                </div>
                <div class="f-c-999">余{{ item.remain_count }}</div>
              </div>
              <!-- <div class="grid_l" v-if="item.holidaytag">
                {{ item.holidaytag }}
              </div>
              <div class="grid_r" v-if="item.holidaytag">休</div> -->
            </div>
          </div>
        </div>
        <!-- 右下 -->
        <div
          :style="{
            height: tableHeight - 112 + 'px',
            width: tableWidth - 170 + 'px',
          }"
          class="right-bom scroll3"
          @scroll="handleScroll"
        >
          <section @click="handleEvent">
            <ul v-for="(item, index) in conditionData.stock" :id="'row-' + index" :key="'s' + index" :data-index="index" class="bom-cell">
              <li v-for="(it, ix) in item" :key="'i' + ix" :data-indexc="ix" @mouseout="handleMouseOut(it)" @mouseover="handleMouseOver(it)">
                <div
                  :id="'box-' + it.id"
                  :class="{
                    isHouse: it.type == 1,
                    orderCell: handleOrderBorder(it),
                  }"
                  :style="{
                    color: '#fff',
                  }"
                  class="cell-grid"
                >
                  <!--房型-->
                  <div v-if="it.type == 1" class="residue" style="color: #000000">余{{ it.remain_count }}</div>
                  <!--房间-->
                  <div
                    v-else-if="it.orderInfo.id && it.is_show == 1"
                    :class="{
                      orderActive: houseItem?.orderInfo?.id == it?.orderInfo?.id,
                    }"
                    :style="{
                      backgroundColor: it.orderInfo.color || statusBgc(it),
                      borderLeft: '5px solid ' + it.orderInfo.source_color,
                      width: it.merge_cells * 90 - 3 + 'px',
                    }"
                    class="boxAuto"
                  >
                    <div class="source_name">
                      <text class="u-line-1">{{ it.orderInfo.source_name }} </text>
                      <div v-if="it.orderInfo.type == 6" class="nights" style="backgroundcolor: green">分</div>
                      <div v-if="it.orderInfo.tenant_verify != 2" :style="{ backgroundColor: authBgc(it.orderInfo.tenant_verify) }" class="nights">证</div>
                      <div v-if="it.orderInfo.deposit_id && it.orderInfo.deposit_amount > 0 && it.orderInfo.deposit_status == 1" class="nights" style="backgroundcolor: #da0000">押</div>
                      <div
                        v-if="
                          it.orderInfo.deposit_id &&
                          it.orderInfo.deposit_amount > 0 &&
                          it.orderInfo.deposit_status == 2 &&
                          (it.orderInfo_status == 5 || it.orderInfo_status == 6) &&
                          it.orderInfo.deposit_refund_status != 2
                        "
                        class="nights"
                        style="backgroundcolor: #da0000"
                      >
                        退
                      </div>
                      <div v-if="it.orderInfo.nights > 3 || new Date(it.orderInfo.start_date).getTime() < new Date(start_date).getTime()" class="nights">
                        {{ it.orderInfo.nights }}
                      </div>
                    </div>
                    <div class="tname">
                      <text v-if="it.orderInfo.company_remark" class="u-line-1 f-c-red">{{ it.orderInfo.company_remark }} </text>
                      <text v-else-if="it.orderInfo.tname" class="u-line-1">{{ it.orderInfo.tname }} </text>
                      <text v-else class="f-c-999">未登记</text>
                    </div>
                  </div>
                  <!-- 锁房 -->
                  <div v-if="it.status == 3" class="isClose">
                    <div class="iconfont icon-taocan-suoxiao"></div>
                  </div>
                  <!-- 任务 备注 -->
                  <div v-if="it.task_id || it.remark" class="task">
                    <div v-if="it.remark" class="iconfont icon-beizhu1" style="font-size: 14px"></div>
                    <div v-if="it.task_id" :style="{ color: taskColor(it), fontSize: '14px' }" class="iconfont icon-saoba"></div>
                  </div>
                  <!-- 冲突 -->
                  <div v-if="it.order_type == 2" class="clash"></div>
                </div>
              </li>
            </ul>
            <div style="height: 50px; width: 100px"></div>
          </section>

          <!-- 换房操作-form -->
          <div
            v-show="startItem.show"
            :style="{
              top: startItem.top + 'px',
              left: startItem.left + 'px',
              width: dayNights * 90 + 'px',
            }"
            class="change-start"
            @click="startChangeClick"
          >
            <a-button v-if="!isRowHouse" danger shape="round" type="primary" @click.stop="closeChangeRoom">取消 </a-button>
          </div>
          <!-- 换房操作-to -->
          <div
            v-show="endItem.show"
            :style="{
              top: endItem.top + 'px',
              left: endItem.left + 'px',
              width: dayNights * 90 + 'px',
            }"
            class="change-end"
          >
            <div class="change-close" @click.stop="closeChangeRoom">X</div>
            <template v-if="changeType == 'change'">
              <a-button v-show="isChangePass && showbtn" :loading="changLoading" class="btn-primary" shape="round" @click="confirmChangeRoom">
                {{ isRowHouse ? '排房' : '换房' }}
              </a-button>
              <span v-show="!isChangePass && showbtn" style="color: #fff">余房不足</span>
            </template>
            <template v-else-if="changeType == 'merge'">
              <a-button v-if="isChangePass && showbtn" :loading="changLoading" class="btn-primary" shape="round" @click="confirmChangeRoom"> 合并 </a-button>
              <span v-if="!isChangePass && showbtn" style="color: #fff">不可合并</span>
            </template>
          </div>
        </div>
        <!-- 左滚动 -->
        <div id="left-srocll-btn" :style="{ top: tableHeight / 2 - 25 + 'px' }" class="left-srocll-btn" @click="leftSrocll">
          <left-outlined />
        </div>
        <!-- 右滚动 -->
        <div
          id="right-srocll-btn"
          :style="{
            top: tableHeight / 2 - 25 + 'px',
            right: 0 + 'px',
          }"
          class="right-srocll-btn"
          @click="rightSrocll"
        >
          <right-outlined />
        </div>
      </div>
      <a-spin :spinning="isLoading" class="spin" size="large" @click.stop=""></a-spin>
    </div>
  </div>

  <!-- 操作 -->
  <div v-if="!isExpired" class="oper-box">
    <a-tooltip color="#000000aa" placement="top" title="往前15天">
      <div class="oper-lef" @click="handleScrollL">
        <left-outlined />
      </div>
    </a-tooltip>
    <div class="oper-cen">
      <a-tooltip color="#000000aa" placement="top" title="今天">
        <div class="oper-cen-one" style="font-size: 17px" @click="toToday">今</div>
      </a-tooltip>
      <a-tooltip color="#000000aa" placement="top" title="刷新">
        <div class="oper-cen-one" style="font-size: 18px" @click="init">
          <sync-outlined />
        </div>
      </a-tooltip>
      <a-tooltip color="#000000aa" placement="top" title="今日任务">
        <div class="oper-cen-one" @click="showOrderTask = true">
          <div class="iconfont icon-PMS_renwudan" style="font-size: 20px"></div>
        </div>
      </a-tooltip>
      <a-tooltip color="#000000aa" placement="top" title="订单盒子">
        <div class="oper-cen-one" @click="orderBoxShow = true">
          <div class="iconfont icon-yichangyuyue" style="font-size: 20px"></div>
        </div>
      </a-tooltip>
      <a-tooltip color="#000000aa" placement="top" title="读取订单">
        <div class="oper-cen-one" @click="readingOrder">
          <div class="iconfont icon-sousuodingdan" style="font-size: 19px"></div>
        </div>
      </a-tooltip>
    </div>
    <a-tooltip color="#000000aa" placement="top" title="往后15天">
      <div class="oper-rig" @click="handleScrollR">
        <right-outlined />
      </div>
    </a-tooltip>
  </div>

  <!-- 订单格子操作 -->
  <div
    :style="{
      top: positionTop + 'px',
      left: handleOperLeft(),
    }"
    class="oper-pop"
  >
    <div v-show="houseInfo?.orderInfo?.id" class="oper-item">
      <div v-show="houseInfo?.orderInfo?.status == 3" class="oper-one" @click="handleCheckIn">入住</div>
      <div v-show="houseInfo?.orderInfo?.status == 4" class="oper-one" @click="handleCancelCheckIn">撤销入住</div>
      <div v-show="houseInfo?.orderInfo?.status == 4" class="oper-one" @click="handleCheckOut">退房</div>
      <div v-show="houseInfo?.orderInfo?.status == 6" class="oper-one" @click="handleRevokeCheckOut">撤销退房</div>
      <div v-show="houseInfo?.orderInfo?.status == 6" class="oper-one" @click="openEnterOrder">下单</div>
      <div
        v-show="houseInfo?.orderInfo?.status == 3"
        class="oper-one"
        @click="
          startChangeRoom('change');
          isRowHouse = false;
        "
      >
        换房
      </div>
      <div v-show="houseInfo?.orderInfo?.status == 3 || houseInfo?.orderInfo?.status == 4" class="oper-one" @click="startChangeRoom('merge')">合并</div>
      <div v-show="houseInfo?.orderInfo?.status == 3 || houseInfo?.orderInfo?.status == 4" class="oper-one" @click="handleAddBox">撤销排房</div>
      <div v-show="houseInfo?.orderInfo?.status == 4" class="oper-one" @click="stayOver">续住</div>
      <div v-show="houseInfo?.orderInfo?.status == 3 || houseInfo?.orderInfo?.status == 4" class="oper-one" @click="chargeUp">记账</div>
      <div v-show="houseInfo?.orderInfo?.status != 6" class="oper-one" @click="shareOrder">分享</div>
      <div v-show="houseItem?.task_id" class="oper-one" @click="openTasks">保洁</div>
      <div v-show="!houseItem?.task_id && selDate?.length == 1" class="oper-one" @click="openTasks">保洁</div>
      <div class="oper-one" @click="dayRemark('order')">备忘</div>
    </div>
    <div v-show="!houseInfo?.orderInfo?.id" class="oper-item">
      <div v-show="houseItem?.order_type == 2" class="oper-one" @click="otherOrder()">现有订单</div>
      <div class="oper-one" @click="openEnterOrder">下单</div>
      <div v-show="houseItem?.status != 3" class="oper-one" @click="handleCloseHouse">锁房</div>
      <div v-show="houseItem?.status == 3" class="oper-one" @click="handleOpenHouse">开房</div>
      <div v-show="houseItem?.task_id" class="oper-one" @click="openTasks">保洁</div>
      <div v-show="!houseItem?.task_id && selDate.length == 1" class="oper-one" @click="openTasks">保洁</div>
      <div v-show="selDate.length == 1" class="oper-one" @click="dayRemark('day')">备忘</div>
      <!-- <div class="oper-one" @click="handleRead">读取订单</div> -->
    </div>
  </div>

  <!-- 气泡弹窗 -->
  <div
    :style="{
      top: bubbleTop + 'px',
      left: handleBubbleLeft(),
    }"
    class="bubble"
  >
    <div class="bubble-con">
      <div class="bubble-arrow">
        <span class="bubble-arrow-con"></span>
      </div>
      <div class="bubble-title line-1">
        <span v-if="bubbleItem.orderInfo.tname"> {{ bubbleItem.orderInfo.tname }}，{{ bubbleItem.orderInfo.tphone }} </span>
        <div v-else>未登记</div>
      </div>
      <div class="bubble-info">
        <div class="f-12">
          <div class="line-1"><span class="f-c-999">来源：</span>{{ bubbleItem.orderInfo.source_name }}（{{ bubbleItem.orderInfo.out_trade_no }}）</div>
          <div>
            <span class="f-c-999">时间：</span>{{ dayjs(bubbleItem.orderInfo.start_date).format('MM-DD') }}入住，{{ dayjs(bubbleItem.orderInfo.end_date).format('MM-DD') }}退房（共{{
              bubbleItem.orderInfo.nights
            }}晚）
          </div>
          <div><span class="f-c-999">房费：</span>¥{{ bubbleItem.orderInfo.total_amount }}</div>
          <div><span class="f-c-999">佣金：</span>¥{{ bubbleItem.orderInfo.royalty }}（净房费：{{ bubbleItem.orderInfo.room_price }}）</div>
          <div>
            <span class="f-c-999">备注：</span>
            <span>{{ bubbleItem.orderInfo.company_remark }}</span>
          </div>
          <div class="line-1">
            <span class="f-c-999">订单备注：</span>
            <span>{{ bubbleItem.orderInfo.user_remark }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- 录入订单 -->
  <enter-order ref="enterOrder" :params="enterOrderParams" :showDayRemark="true" :tab="orderTab" @refresh="enterOrderRefresh" />

  <!-- 订单详情 -->
  <order-details
    ref="orderDetails"
    v-model:visible="detShow"
    :orderId="orderId"
    :other="other"
    :remarkDay="houseItem.date"
    :showDayRemark="true"
    :tab="orderDetTab"
    @changeRoom="detailsChangeRoom"
    @refreshOrderDetails="init"
  />

  <!-- 订单盒子 -->
  <order-box ref="orderBoxRef" :boxShow="orderBoxShow" @orderBoxClose="orderBoxShow = false" />

  <!-- 添加任务 -->
  <AddTasks v-model:visible="showTaskAdd" :date="taskDate" :form="null" :hid="taskHid" title="创建任务" @confirm="init" />

  <!-- 任务详情 -->
  <TasksDetails v-model:visible="showTaskDet" :taskId="taskId" @refresh="init"></TasksDetails>

  <!-- 订单任务 -->
  <OrderTask v-model:visible="showOrderTask"></OrderTask>

  <!-- 读取订单 -->
  <Reading v-if="!isExpired" :params="readingParams" @refresh="init" />

  <!-- 房源到期提示 -->
  <div v-if="isExpired" class="expire-tip">
    <div class="expire-content">
      <div class="expire-title">房源已到期</div>
      <div class="expire-info">到期时间：{{ expireDate }}</div>
      <div class="expire-renew">续费路径：手机端 我的->房源管理->购买付费</div>
    </div>
  </div>
</template>

<script>
import Reading from '@/components/pms/landlord/Reading/Reading.vue';
import AddTasks from '../../../../components/pms/landlord/tasks/Add.vue';
import TasksDetails from '../../../../components/pms/landlord/tasks/Details.vue';
import OrderTask from '../../../../components/pms/landlord/OrderTask/OrderTask.vue';
import { createVNode, nextTick, onMounted, onUnmounted, reactive, toRefs } from 'vue';
import store from '@/store/pms/landlord/index';
import dayjs from 'dayjs';
import {
  closeHouse,
  getCompanyConfig,
  getHeadList,
  getSearchList,
  HouseStatusgetListNew,
  mergeOrder,
  moveBoxOrder,
  openHouse,
  orderChangeRoom,
  orderCheckout,
  orderConfirmIn,
  orderRevokeCheckin,
  orderRevokeCheckOut,
} from '@/api/api';
import useUtils from '@/hooks/useUtils.js';
import { message, Modal } from 'ant-design-vue';
import { verifyIdcard, verifyPhone, verifyPrice } from '@/common/validator';
import OrderDetails from '@/components/pms/landlord/OrderDetails/OrderDetails.vue';
import orderBox from '@/components/pms/landlord/orderBox/orderBox.vue';
import EnterOrder from '@/components/pms/landlord/EnterOrder/EnterOrder.vue';
import { ExclamationCircleOutlined, LeftOutlined, RightOutlined, SyncOutlined } from '@ant-design/icons-vue';

export default {
  components: {
    orderBox,
    Reading,
    OrderDetails,
    AddTasks,
    TasksDetails,
    EnterOrder,
    LeftOutlined,
    RightOutlined,
    SyncOutlined,
    // CheckCircleOutlined,
    OrderTask,
  },
  setup() {
    const { imgCut } = useUtils();
    // 换房
    const changeRoom = reactive({
      startItem: {
        data: {},
        show: false,
        top: 0,
        left: -999,
      },
      endItem: {
        data: {},
        show: false,
        top: 0,
        left: -999,
      },
      dayNights: 1,
      isChangePass: false,
      changLoading: false,
      isRowHouse: false, //是否排房
      showbtn: false,
      // 换房点击订单
      endChangeClick(it, e) {
        const x = e.offsetX;
        const n = Math.floor(x / 90);
        const data = {
          id: it.id,
          hid: it.hid,
          date: dayjs(it.date).add(n, 'day').format('YYYY-MM-DD'),
          orderInfo: it.orderInfo,
        };
        changeRoom.endChangeRoom(data);
        nextTick(() => {
          changeRoom.endItem.left = changeRoom.endItem.left + n * 90;
        });
      },
      // 换房点击开始盒子
      startChangeClick(e) {
        const x = e.offsetX;
        const n = Math.floor(x / 90);
        if (!n && !changeRoom.isRowHouse) return;
        const data = {
          id: changeRoom.startItem.data.id,
          hid: changeRoom.startItem.data.hid,
          date: dayjs(changeRoom.startItem.data.date).add(n, 'day').format('YYYY-MM-DD'),
        };
        changeRoom.endChangeRoom(data);
        nextTick(() => {
          changeRoom.endItem.left = changeRoom.endItem.left + n * 90;
        });
      },
      // 订单换房回调
      detailsChangeRoom(e) {
        tabel.houseItem.orderInfo.id = e.order_id;
        tabel.houseItem.id = e.stockId;
        tabel.houseItem.stockId = e.stockId;
        tabel.houseItem.date = e.start_date;
        tabel.houseItem.orderInfo.nights = e.orderInfo.nights;
        changeRoom.isRowHouse = e.type == 2 ? true : false;
        changeRoom.startChangeRoom('change');
        if (e.type == 2) {
          changeRoom.endChangeRoom(tabel.houseItem);
        }
      },
      // 换房确认
      confirmChangeRoom() {
        changeRoom.changLoading = true;
        changeRoom
          .checkChangeRoom(changeRoom.startItem.data, changeRoom.endItem.data, 1)
          .then(res => {
            message.success(res.msg);
            tabel.init();
          })
          .finally(() => {
            changeRoom.closeChangeRoom();
            changeRoom.changLoading = false;
          });
      },
      // 取消换房
      closeChangeRoom() {
        changeRoom.startItem.show = false;
        changeRoom.endItem.show = false;
      },
      // 换房_结束
      endChangeRoom(it) {
        changeRoom.endItem.show = true;
        changeRoom.endItem.data = it;
        const id = changeRoom.endItem.data.id;
        const selDom = document.getElementById('box-' + id);
        changeRoom.endItem.top = selDom.offsetTop;
        changeRoom.endItem.left = selDom.offsetLeft;
        changeRoom
          .checkChangeRoom(changeRoom.startItem.data, changeRoom.endItem.data, 2)
          .then(() => {
            changeRoom.isChangePass = true;
          })
          .catch(() => {
            changeRoom.isChangePass = false;
          });
      },
      changeType: 'change', //change 换房  merge 合并
      // 换房_开始
      startChangeRoom(type = 'change') {
        changeRoom.changeType = type;
        tabel.cleanActive();
        tabel.isOrderPopShow = false;
        order.detShow = false;
        order.enterOrderParams.show = false;
        changeRoom.startItem.show = true;
        if (tabel.houseItem.is_show == 0) {
          tabel.houseItem.id = tabel.houseItem.stockId ? tabel.houseItem.stockId : tabel.houseItem.id;
        }
        changeRoom.startItem.data = tabel.houseItem;
        changeRoom.dayNights = tabel.houseItem.orderInfo.nights;
        const id = changeRoom.startItem.data.id;
        const selDom = document.getElementById('box-' + id);
        changeRoom.startItem.top = selDom.offsetTop;
        changeRoom.startItem.left = selDom.offsetLeft;
      },
      // 换房检查/确定
      checkChangeRoom(formItem, toItem, type) {
        changeRoom.showbtn = type == 1 ? true : false;
        return new Promise((resolve, reject) => {
          // 换房
          if (changeRoom.changeType == 'change') {
            orderChangeRoom({
              order_id: formItem.orderInfo.id,
              hid: toItem.hid,
              to_start_date: toItem.date,
              confirm: type,
            })
              .then(res => {
                changeRoom.showbtn = true;
                if (type == 2) {
                  if (res.data.allow == 1) {
                    resolve(res);
                  } else {
                    reject();
                  }
                } else {
                  resolve(res);
                }
              })
              .catch(() => {
                reject();
              });
          } else if (changeRoom.changeType == 'merge') {
            mergeOrder({
              order_id: formItem.orderInfo.id,
              merge_id: toItem.orderInfo.id || 0,
              confirm: type,
            })
              .then(res => {
                changeRoom.showbtn = true;
                if (type == 2) {
                  if (res.data.allow == 1) {
                    resolve(res);
                  } else {
                    reject();
                  }
                } else {
                  resolve(res);
                }
              })
              .catch(() => {
                reject();
              });
          }
        });
      },
    });
    // 搜索
    const searchs = reactive({
      searchLoading: false,
      searchRef: '',
      topRef: '',
      searchList: [],
      searchForm: {
        keyword: '',
        rids: [],
        gids: [],
        type: [],
        store_id: [],
        start_date: '',
      },
      readingParams: {
        title: '读取订单',
        sync_ids: '2',
        show: false,
      },
      readingOrder() {
        searchs.readingParams.show = true;
      },
      // 获取查询参数列表
      getSearchList() {
        getSearchList().then(res => {
          searchs.searchList = res.data;
        });
      },
      changeStartDate() {
        if (searchs.searchForm.start_date) {
          tabel.start_date = dayjs(searchs.searchForm.start_date).format('YYYY-MM-DD');
        } else {
          tabel.toToday();
        }
        tabel.init();
      },
      searchingId: [],
      searchingIndex: 0,
      // 下一条
      searchNext() {
        if (searchs.searchingIndex + 2 > searchs.searchingId.length) return;
        searchs.searchingIndex += 1;
        tabel.isOrderPopShow = false;
        searchs.searchLocat(searchs.searchingId[searchs.searchingIndex]);
      },
      // 上一条
      searchLast() {
        if (searchs.searchingIndex == 0) return;
        searchs.searchingIndex -= 1;
        tabel.isOrderPopShow = false;
        searchs.searchLocat(searchs.searchingId[searchs.searchingIndex]);
      },
      // 搜索
      search(e) {
        if (!e) {
          searchs.searchingId = [];
          return;
        }
        const keyword = e.replace(' ', '');
        searchs.searchLoading = true;
        let id = '';
        searchs.searchingId = [];
        for (let i = 0; i < tabel.conditionData.menu.length; i++) {
          if (tabel.conditionData.menu[i].hname.includes(keyword)) {
            id = 'h-' + tabel.conditionData.menu[i].hid;
            searchs.searchingId.push(id);
          }
        }
        // if (!id) {
        for (let i = 0; i < tabel.conditionData.stock.length; i++) {
          // if (id) break;
          for (let ic = 0; ic < tabel.conditionData.stock[i].length; ic++) {
            var item = tabel.conditionData.stock[i][ic];
            if (item.type == 1) break;
            if (item.remark && item.remark.includes(keyword)) {
              console.log('1111');
              id = 'box-' + item.id;
              searchs.searchingId.push(id);
            } else if (item.keywords && item.keywords.includes(keyword)) {
              console.log('3333');
              id = 'box-' + item.id;
              searchs.searchingId.push(id);
            } else if (item.orderInfo.id && item.is_show == 1) {
              // 检索订单
              if (
                item.orderInfo.order_no.includes(keyword) ||
                item.orderInfo.tname.includes(keyword) ||
                item.orderInfo.tphone.includes(keyword) ||
                item.orderInfo.out_trade_no.includes(keyword) ||
                item.orderInfo.company_remark.includes(keyword) ||
                item.orderInfo.user_remark.includes(keyword)
              ) {
                console.log('2222');
                id = 'box-' + item.id;
                searchs.searchingId.push(id);
              }
            }
          }
        }
        // }
        searchs.searchLoading = false;
        if (searchs.searchingId.length) {
          searchs.searchingIndex = 0;
          searchs.searchLocat(searchs.searchingId[searchs.searchingIndex]);
        } else {
          message.warn('未找到相关数据');
        }
      },

      // 搜索定位
      searchLocat(id) {
        let topHeight = 52;
        const selDom = document.getElementById(id);
        const scrollDom = document.querySelector('.scroll3');
        if (id.includes('h')) {
          tabel.animateScroll(scrollDom, null, selDom.offsetTop - topHeight);
        } else {
          tabel.animateScroll(scrollDom, selDom.parentNode.offsetLeft, selDom.parentNode.offsetTop);
        }
        selDom.classList.add('highlight');
        setTimeout(() => {
          selDom.classList.remove('highlight');
        }, 2000);
      },
    });
    // 任务
    const task = reactive({
      showTaskAdd: false,
      showTaskDet: false,
      taskHid: '',
      taskDate: '',
      taskId: 0,
      // 处理任务
      openTasks() {
        if (tabel.houseItem.task_id) {
          task.taskId = tabel.houseItem.task_id;
          task.showTaskDet = true;
        } else {
          task.taskHid = tabel.houseItem.hid;
          task.taskDate = tabel.houseItem.date;
          task.showTaskAdd = true;
        }
      },
    });
    // 订单
    const order = reactive({
      orderTab: 1,
      orderDetTab: 1,
      orderBoxShow: false,
      detShow: false,
      orderId: '',
      shareQrCode: '',
      shareSpin: true,
      other: {
        hid: '',
        date: '',
      },
      // 判断订单内盒子边框
      handleOrderBorder(item) {
        if (item.is_show == 0) {
          if (dayjs(item.date).add(1, 'day').format('YYYY-MM-DD') == item.orderInfo.end_date) {
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      },
      // 其他订单
      otherOrder() {
        order.orderId = '';
        order.other.hid = tabel.houseItem.hid;
        order.other.date = tabel.houseItem.date;
        order.detShow = true;
      },

      // 备忘
      dayRemark(type) {
        if (type == 'order') {
          tabel.checkDetails();
          order.orderDetTab = 2;
        } else {
          if (order.enterOrderParams.show) {
            order.enterOrderParams.show = false;
          }
          nextTick(() => {
            order.openEnterOrder();
            order.orderTab = 2;
          });
        }
      },
      // 续住
      stayOver() {
        if (this.$refs.orderDetails) {
          this.$refs.orderDetails.openStayover();
        } else {
          tabel.checkDetails();
          nextTick(() => {
            this.$refs.orderDetails.openStayover();
          });
        }
      },
      // 记账
      chargeUp() {
        if (this.$refs.orderDetails) {
          this.$refs.orderDetails.accountShow = true;
        } else {
          tabel.checkDetails();
          nextTick(() => {
            this.$refs.orderDetails.accountShow = true;
          });
        }
      },

      // 分享
      shareOrder() {
        if (this.$refs.orderDetails) {
          this.$refs.orderDetails.checkInGuide();
        } else {
          tabel.checkDetails();
          nextTick(() => {
            this.$refs.orderDetails.checkInGuide();
          });
        }
      },
      //  移入订单盒子
      handleAddBox() {
        Modal.confirm({
          title: '提示',
          content: '是否撤销排房?',
          icon: createVNode(ExclamationCircleOutlined),
          centered: true,
          onOk() {
            moveBoxOrder({
              order_id: tabel.houseItem.orderInfo.id,
            }).then(res => {
              message.success(res.msg);
              tabel.init();
            });
          },
        });
      },
      // 撤销退房
      handleRevokeCheckOut() {
        Modal.confirm({
          title: '提示',
          content: '是否撤销退房?',
          icon: createVNode(ExclamationCircleOutlined),
          centered: true,
          onOk() {
            orderRevokeCheckOut({
              order_id: tabel.houseItem.orderInfo.id,
            }).then(res => {
              message.success(res.msg);
              tabel.init();
              order.detShow = false;
              nextTick(() => {
                tabel.checkDetails();
              });
            });
          },
        });
      },
      // 退房
      handleCheckOut() {
        Modal.confirm({
          title: '提示',
          content: '是否退房?',
          icon: createVNode(ExclamationCircleOutlined),
          centered: true,
          onOk() {
            orderCheckout({
              order_id: tabel.houseItem.orderInfo.id,
            }).then(res => {
              message.success(res.msg);
              tabel.init();
              order.detShow = false;
              nextTick(() => {
                tabel.checkDetails();
              });
            });
          },
        });
      },
      // 入住
      handleCheckIn() {
        Modal.confirm({
          title: '提示',
          content: '是否入住?',
          icon: createVNode(ExclamationCircleOutlined),
          centered: true,
          onOk() {
            orderConfirmIn({
              order_id: tabel.houseItem.orderInfo.id,
            }).then(res => {
              message.success(res.msg);
              tabel.init();
              order.detShow = false;
              nextTick(() => {
                tabel.checkDetails();
              });
            });
          },
        });
      },

      // 撤销入住
      handleCancelCheckIn() {
        Modal.confirm({
          title: '提示',
          content: '是否撤销入住?',
          icon: createVNode(ExclamationCircleOutlined),
          centered: true,
          onOk() {
            orderRevokeCheckin({
              order_id: tabel.houseItem.orderInfo.id,
            }).then(res => {
              message.success(res.msg);
              tabel.init();
              order.detShow = false;
              nextTick(() => {
                tabel.checkDetails();
              });
            });
          },
        });
      },
      // 录入订单回调
      enterOrderRefresh(type) {
        if (type == 'init') {
          tabel.isOrderPopShow = false;
          order.enterOrderParams.show = false;
          tabel.init();
        } else if (type == 'close') {
          order.enterOrderParams.show = false;
        } else {
          tabel.init();
        }
      },
      // 录入订单
      enterOrderParams: {
        show: false,
        hid: '',
        date: [],
      },
      // 打开录入订单窗口
      openEnterOrder() {
        order.orderTab = 1;
        order.detShow = false;
        if (order.enterOrderParams.show) {
          order.enterOrderParams.show = false;
        }
        nextTick(() => {
          order.enterOrderParams.show = true;
          order.enterOrderParams.hid = tabel.houseInfo.hid;
          order.enterOrderParams.date = tabel.selDate;
        });
      },
    });
    // 表格
    const tabel = reactive({
      showMiniTabel: false, //精简表格
      showOrderTask: false,
      showLeftSrocll: false,
      showRightSrocll: true,
      scrollbarWidth: 0,
      conditionData: {
        menu: [],
        stock: [],
      },
      headList: [],
      companyInfo: {
        logo: JSON.parse(sessionStorage.getItem('companyInfo'))?.logo,
      },
      dates: {
        today: dayjs().format('MM-DD'),
        toyear: dayjs().format('YYYY-MM-DD'),
      },
      tableHeight: store.state.ContentHeight,
      tableWidth: store.state.ContentWidth,
      isLoading: false,
      start_date: dayjs().subtract(3, 'day').format('YYYY-MM-DD'),
      today: dayjs().format('YYYY-MM-DD'),
      selDate: [], // 选中时间
      houseItem: '',
      houseInfo: '',
      stime: '',
      etime: '',
      isOrderPopShow: false,
      isBubbleShow: false,
      bubbleItem: {
        orderInfo: {},
      },
      positionTop: 0,
      positionLeft: 0,
      bubbleTop: 0,
      bubbleLeft: 0,
      bubbleTimer: '',
      isActiveList: [],
      currentActive: false,
      isExpired: false,
      expireDate: '',
      optionFilter(input, option) {
        return option.children[0].children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
      },
      handleBubbleLeft() {
        if (tabel.isBubbleShow) {
          return tabel.bubbleLeft + 'px';
        } else {
          return '-999px';
        }
      },
      handleOperLeft() {
        if (tabel.isOrderPopShow) {
          return tabel.positionLeft + 'px';
        } else {
          return '-999px';
        }
      },
      // 鼠标移出
      handleMouseOut(item) {
        clearTimeout(tabel.bubbleTimer);
        if (tabel.currentActive) {
          const hid = 'h-' + item.hid;
          const did = 'd-' + item.day;
          const hdom = document.getElementById(hid);
          const ddom = document.getElementById(did);
          hdom.classList.remove('mouse-current');
          ddom.classList.remove('mouse-current');
          tabel.isBubbleShow = false;
          tabel.currentActive = false;
        }
      },
      // 鼠标移入
      handleMouseOver(item) {
        if (!item.hid) return;
        tabel.bubbleTimer = setTimeout(() => {
          tabel.currentActive = true;
          const hid = 'h-' + item.hid;
          const did = 'd-' + item.day;
          const hdom = document.getElementById(hid);
          const ddom = document.getElementById(did);
          hdom.classList.add('mouse-current');
          ddom.classList.add('mouse-current');
          if (item.orderInfo.id) {
            tabel.bubbleItem = item;
            tabel.isBubbleShow = true;
            const id = 'box-' + item.id;
            const selDom = document.querySelector('#' + id);
            const local = selDom.getBoundingClientRect();
            tabel.bubbleTop = local.top - 190;
            tabel.bubbleLeft = local.left;
          }
        }, 300);
      },

      // 查看订单
      checkDetails() {
        order.orderDetTab = 1;
        order.orderId = tabel.houseItem.orderInfo.id;
        order.detShow = true;
      },

      // 开房
      handleOpenHouse() {
        openHouse({
          hid: tabel.houseItem.hid,
          date: tabel.selDate.join(','),
        }).then(res => {
          message.success(res.msg);
          tabel.isOrderPopShow = false;
          tabel.init();
        });
      },
      // 关房
      handleCloseHouse() {
        closeHouse({
          hid: tabel.houseItem.hid,
          date: tabel.selDate.join(','),
        }).then(res => {
          message.success(res.msg);
          tabel.isOrderPopShow = false;
          tabel.init();
        });
      },

      // 跳转今天
      toToday() {
        tabel.start_date = dayjs(tabel.today).subtract(3, 'day').format('YYYY-MM-DD');
        tabel.init();
        nextTick(() => {
          document.querySelector('.scroll3').scrollLeft = 0;
          document.querySelector('.scroll3').scrollTop = 0;
        });
      },

      // 计算日期差
      diffDate: function (stime, etime) {
        if (stime > etime) {
          [stime, etime] = [etime, stime];
        }
        let dates = new Array();
        while (stime <= etime) {
          dates.push(stime);
          let stime_ts = new Date(stime).getTime();
          let next_date = stime_ts + 24 * 60 * 60 * 1000;
          let nextD = new Date(next_date);
          stime = `${nextD.getFullYear()}-${(nextD.getMonth() + 1 + '').padStart(2, '0')}-${(nextD.getDate() + '').padStart(2, '0')}`;
        }
        return dates;
      },
      // 事件委托
      handleEvent(event) {
        if (tabel.isLoading) return;
        const childElement = event.target;
        let parentElement = childElement.parentNode;
        let index = '';
        let indexc = '';
        while (parentElement) {
          const pindex = parentElement.getAttribute('data-index');
          if (pindex) {
            index = pindex;
          }
          const cindex = parentElement.getAttribute('data-indexc');
          if (cindex) {
            indexc = cindex;
          }
          if (index && indexc) {
            break;
          }
          parentElement = parentElement.parentNode;
        }
        const item = this.conditionData.stock[index];
        const it = item[indexc];
        if (it.type == 1) return;
        // 换房操作
        if (changeRoom.startItem.show) {
          // 换房点击订单
          if (it.orderInfo.id) {
            changeRoom.endChangeClick(it, event);
          } else {
            changeRoom.endChangeRoom(it);
          }
          return;
        }
        this.handleSelDate(it, indexc, item);
      },

      // 清除重置选中记录
      cleanActive() {
        if (tabel.isActiveList.length) {
          tabel.isActiveList.forEach(i => {
            const id = 'box-' + i;
            const selDom = document.querySelector('#' + id);
            if (selDom) {
              selDom.classList.remove('isActive');
              selDom.classList.remove('isActiveOrder');
            }
          });
        }
        tabel.isActiveList = [];
      },

      // 选中订单 日历
      handleSelDate(it, ix, item) {
        tabel.cleanActive();
        // 订单ID -> 订单详情
        if (it.orderInfo.id) {
          // if (
          //   this.houseItem &&
          //   this.houseItem.orderInfo.id == it.orderInfo.id
          // ) {
          //   this.houseItem = "";
          //   this.houseInfo = "";
          //   this.selDate = [];
          //   this.etime = "";
          //   this.stime = "";
          // } else {
          this.stime = it.orderInfo.start_date;
          this.etime = it.orderInfo.end_date;
          this.houseItem = JSON.parse(JSON.stringify(it));
          this.houseInfo = it;
          // this.selDate = [it.orderInfo.start_date];
          this.selDate.push(it.date);
          // }
        } else if (this.houseItem.hid == it.hid) {
          if (this.stime && this.etime) {
            this.houseItem = JSON.parse(JSON.stringify(it));
            this.houseInfo = it;
            this.stime = it.date;
            this.etime = '';
            this.selDate = [];
            this.selDate.push(it.date);
          } else if (this.stime == it.date) {
            this.houseItem = '';
            this.houseInfo = '';
            this.selDate = [];
            this.etime = '';
            this.stime = '';
          } else {
            this.houseItem = JSON.parse(JSON.stringify(it));
            this.houseInfo = it;
            this.etime = it.date;
            this.selDate = tabel.diffDate(this.stime, it.date);
          }
        } else {
          this.houseItem = JSON.parse(JSON.stringify(it));
          this.houseInfo = it;
          this.selDate = [];
          this.etime = '';
          this.stime = it.date;
          this.selDate.push(it.date);
        }
        // 判断选中日期是否存在订单
        if (this.selDate.length > 1) {
          this.selDate.forEach(s => {
            item.forEach(n => {
              if (s == n.date) {
                if (n?.orderInfo?.id > 0) {
                  this.etime = '';
                  this.stime = it.date;
                  this.selDate = [];
                  this.selDate.push(it.date);
                }
              }
            });
          });
        }
        // 获取已选中的日期id
        item.forEach(i => {
          if (this.selDate.includes(i.date)) {
            this.isActiveList.push(i.id);
          }
        });
        this.isActiveList.forEach(i => {
          const id = 'box-' + i;
          const selDom = document.querySelector('#' + id);
          if (this.houseItem?.orderInfo.id) {
            selDom.classList.add('isActiveOrder');
          } else {
            selDom.classList.add('isActive');
          }
        });

        // 计算弹窗定位
        const id = 'box-' + it.id;
        const selDom = document.querySelector('#' + id);
        const local = selDom.getBoundingClientRect();
        this.positionTop = local.top - 31;
        this.positionLeft = local.left;
        // 按钮显示
        if (this.stime || this.etime) {
          order.enterOrderParams.show = false;
          this.isOrderPopShow = true;
          if (tabel.isBubbleShow) {
            tabel.isBubbleShow = false;
          }
          // 显示订单详情
          if (this.houseItem?.orderInfo.id) {
            tabel.checkDetails();
          } else if (this.houseItem.order_type == 2) {
            order.otherOrder();
          } else {
            order.detShow = false;
          }
        } else {
          this.isOrderPopShow = false;
          order.detShow = false;
        }
      },

      // 滚动动画
      animateScroll(element, x = null, y = null) {
        const duration = 50; // 持续时间
        const startLeft = element.scrollLeft; // 开始位置x
        const startTop = element.scrollTop; // 开始位置y
        const changeX = x !== null ? x - startLeft : 0; // 总共需要滚动的距离x
        const changeY = y !== null ? y - startTop : 0; // 总共需要滚动的距离y
        const increment = 10; // 每次增量
        let currentTime = 0;

        function animate() {
          currentTime += increment;
          const valx = tabel.easeInOutQuad(currentTime, startLeft, changeX, duration);
          const valy = tabel.easeInOutQuad(currentTime, startTop, changeY, duration);
          element.scrollLeft = valx;
          element.scrollTop = valy;
          if (currentTime < duration) {
            setTimeout(animate, increment);
          }
        }

        animate();
      },
      easeInOutQuad: function (t, b, c, d) {
        t /= d / 2;
        if (t < 1) {
          return (c / 2) * t * t + b;
        }
        t--;
        return (-c / 2) * (t * (t - 2) - 1) + b;
      },

      // 点击左滚动
      leftSrocll() {
        const element = document.querySelector('.scroll3');
        const scrollLeft = element.scrollLeft;
        tabel.animateScroll(element, scrollLeft - 500);
      },

      // 点击右滚动
      rightSrocll() {
        const element = document.querySelector('.scroll3');
        const scrollLeft = element.scrollLeft;
        tabel.animateScroll(element, scrollLeft + 500);
      },

      // 滚动联动
      handleScroll() {
        // let showLeftSrocll =
        //   document.querySelector(".scroll3").scrollLeft == 0 ? "flex" : "none";
        // let showRightSrocll =
        //   document.querySelector(".scroll3").scrollLeft > 1200
        //     ? "none"
        //     : "flex";
        // document.getElementById("left-srocll-btn").style =
        //   "display:" + showLeftSrocll;
        // document.getElementById("right-srocll-btn").style =
        //   "display:" + showRightSrocll;
        document.querySelector('.scroll1').scrollTop = document.querySelector('.scroll3').scrollTop;
        document.querySelector('.scroll2').scrollLeft = document.querySelector('.scroll3').scrollLeft;
      },

      // 滚动触右
      handleScrollR() {
        tabel.start_date = dayjs(tabel.headList[0].time).add(15, 'day').format('YYYY-MM-DD');
        tabel.init();
        this.$nextTick(() => {
          document.querySelector('.scroll3').scrollLeft = 0;
        });
      },
      // 滚动左
      handleScrollL() {
        tabel.start_date = dayjs(tabel.headList[0].time).subtract(15, 'day').format('YYYY-MM-DD');
        tabel.init();
        this.$nextTick(() => {
          document.querySelector('.scroll3').scrollLeft = 0;
        });
      },

      // 认证背景颜色
      authBgc(verify) {
        if (verify == 2) {
          return '#00aa00';
        } else if (verify == 3) {
          return '#da0000';
        }
      },

      // 任务图标颜色
      taskColor(item) {
        switch (item.task_status) {
          case 1:
            return '#da0000';
          case 2:
            return '#da0000';

          case 3:
            return '#00aaff';

          case 4:
            return '#999999';

          default:
            return '#ffffff';
        }
      },

      // 订单状态背景
      statusBgc(item) {
        switch (item.orderInfo.status) {
          case 3:
            // 待入住
            return '#ffc8b4';

          case 4:
            // 入住中
            return '#f0dc8c';

          case 6:
            // 已退房
            return '#d6d6d6';

          default:
            return '#0094ff';
        }
      },

      // 判断是否为今天日期
      isToday(e) {
        if (new Date(e).getTime() == new Date(tabel.today).getTime()) {
          return true;
        } else {
          return false;
        }
      },

      // 获取房态数据
      getTabelData() {
        tabel.isLoading = true;
        HouseStatusgetListNew({
          begin: tabel.start_date,
          end: dayjs(tabel.start_date).add(20, 'day').format('YYYY-MM-DD'),
          rids: searchs.searchForm.rids.join(','),
          group_ids: searchs.searchForm.gids.join(','),
          store_id: searchs.searchForm.store_id,
          type: searchs.searchForm.type,
        })
          .then(res => {
            tabel.conditionData.menu = res.data.menu;
            tabel.conditionData.stock = res.data.stock;
            // 获取滚动条厚度
            nextTick(() => {
              const div = document.querySelector('.scroll3');
              tabel.scrollbarWidth = div.offsetWidth - div.clientWidth;
            });
          })
          .finally(() => {
            tabel.isLoading = false;
          });
      },
      getHeadList() {
        tabel.isLoading = true;
        getHeadList({
          begin: tabel.start_date,
          end: dayjs(tabel.start_date).add(20, 'day').format('YYYY-MM-DD'),
          rids: searchs.searchForm.rids.join(','),
          group_ids: searchs.searchForm.gids.join(','),
          store_id: searchs.searchForm.store_id,
        }).then(res => {
          tabel.headList = res.data;
        });
      },

      // 初始化表格
      init() {
        tabel.searchingId = [];
        tabel.isOrderPopShow = false;
        order.detShow = false;
        order.enterOrderParams.show = false;
        tabel.houseItem = '';
        tabel.houseInfo = '';
        tabel.selDate = [];
        tabel.etime = '';
        tabel.stime = '';
        changeRoom.closeChangeRoom();
        tabel.cleanActive();
        tabel.getHeadList();
        tabel.getTabelData();
      },
      // 检查公司配置（房源到期时间）
      checkCompanyConfig() {
        getCompanyConfig()
          .then(res => {
            const data = res.data || {};
            // data.expire = true; // TODO: 临时测试，记得删除
            if (data.expire) {
              tabel.isExpired = true;
              tabel.expireDate = data.house_expire_time ? dayjs(data.house_expire_time * 1000).format('YYYY-MM-DD') : '';
            } else {
              tabel.isExpired = false;
              tabel.expireDate = '';
              tabel.init();
              searchs.getSearchList();
            }
          })
          .catch(() => {
            tabel.isExpired = false;
            tabel.expireDate = '';
            tabel.init();
            searchs.getSearchList();
          });
      },
    });

    const watchWidth = store.watch(
      state => state.ContentWidth,
      newValue => {
        tabel.tableWidth = newValue;
      }
    );

    const watchHeight = store.watch(
      state => state.ContentHeight,
      newValue => {
        tabel.tableHeight = newValue;
      }
    );

    onMounted(() => {
      tabel.checkCompanyConfig();
    });

    onUnmounted(() => {
      watchWidth();
      watchHeight();
    });

    return {
      ...toRefs(task),
      // ...toRefs(messages),
      // ...toRefs(operations),
      // ...toRefs(addPersons),
      // ...toRefs(drawers),
      ...toRefs(order),
      ...toRefs(tabel),
      ...toRefs(searchs),
      ...toRefs(changeRoom),
      dayjs,
      imgCut,
      verifyPrice,
      verifyPhone,
      verifyIdcard,
    };
  },
};
</script>
<style lang="scss" scoped>
// 变量定义必须在选择器之前
$box-border-color: #e3e3e3;
$house-type-bgc: #fafafa;
$tabelWidth: 90px;
$tabelHeight: 50px;
$houseWidth: 150px;

:deep(.ant-popover-inner-content) {
  max-width: 300px;
}

.search-tip {
  .search-last {
    color: #0094ff;
    margin-right: 6px;
    cursor: pointer;
  }

  .search-next {
    color: #0094ff;
    cursor: pointer;
  }
}

.spin {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  line-height: 50;
  background-color: #ebebeb;
  backdrop-filter: blur(10px);
  clear: both;
  overflow: hidden;
  opacity: 0.5;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  pointer-events: none;
  z-index: 99999;
}

.mouse-current {
  background-color: #e6f5ff;
}

// 换房列表
.rooms {
  overflow-y: auto;
  height: 60vh;

  .room_box {
    display: flex;
    align-items: center;
    // background-color: pink;

    .box_img {
      margin-right: 10px;
      border-radius: 6px;
      overflow: hidden;
    }

    .box_name {
      .name_h {
      }

      .name_r {
      }
    }
  }
}

.bubble {
  position: absolute;
  text-align: center;
  display: flex;
  justify-content: center;
  z-index: 999;
  border-radius: 5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

  .bubble-con {
    position: relative;
    background-color: white;
    width: 250px;
    height: 200px;
    text-align: left;
    color: #000000;
    padding: 6px 0;

    .bubble-arrow {
      position: absolute;
      left: 20%;
      bottom: -4px;
      display: block;
      overflow: hidden;
      transform: rotate(45deg);

      .bubble-arrow-con {
        display: block;
        width: 8px;
        height: 8px;
        margin: auto;
        background-color: white;
        pointer-events: auto;
      }
    }

    .bubble-title {
      border-bottom: 1px solid #f0f0f0;
      padding: 5px 0;
      margin-bottom: 10px;
      padding: 6px 14px;
    }

    .bubble-info {
      padding: 6px 14px;
    }
  }
}

.oper-pop {
  position: absolute;
  text-align: center;
  display: flex;
  justify-content: center;
  z-index: 999;

  @keyframes scale-in-ver-bottom {
    0% {
      transform: scaleY(0);
      transform-origin: 0% 100%;
      opacity: 1;
    }

    100% {
      transform: scaleY(1);
      transform-origin: 0% 100%;
      opacity: 1;
    }
  }

  .oper-item {
    z-index: 10074;
    background-color: #000000be;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 0 10px;
    color: #fff;
    font-size: 14px;
    border-radius: 5px;
    // width: 600rpx;
    line-height: 1.5;

    .oper-one {
      padding: 5px 10px;
      cursor: pointer;

      &:hover {
        background-color: #000000cb;
      }
    }
  }
}

// 换房开始
.change-start {
  position: absolute;
  height: calc(#{$tabelHeight} - 2px);
  display: flex;
  align-items: center;
  background-color: rgba(255, 255, 0, 0.349);
  border: dashed 1px #da0000;
  padding: 0 10px;
}

.change-end {
  position: absolute;
  height: calc(#{$tabelHeight});
  display: flex;
  align-items: center;
  background-color: rgba(26, 115, 232, 0.4);
  border: dashed 1px #1a73e8;
  padding: 0 10px;

  .change-close {
    position: absolute;
    left: -1px;
    bottom: -20px;
    height: 20px;
    width: 20px;
    background-color: #000000aa;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
}

.oper-box {
  position: fixed;
  bottom: 30px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 30;
  text-align: center;
  color: #fff;

  .oper-lef {
    height: 40px;
    width: 40px;
    border-radius: 50%;
    background-color: #000000aa;
    margin-right: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    padding-right: 3px;
    cursor: pointer;

    &:hover {
      background-color: #3b3b3b;
      border-radius: 50%;
    }
  }

  .oper-cen {
    height: 40px;
    border-radius: 25px;
    background-color: #000000aa;
    margin-right: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    padding: 0 10px;

    .oper-cen-one {
      margin: 0 6px;
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      &:hover {
        background-color: #3b3b3b;
        border-radius: 50%;
      }
    }
  }

  .oper-rig {
    height: 40px;
    width: 40px;
    border-radius: 50%;
    background-color: #000000aa;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    padding-left: 3px;
    cursor: pointer;

    &:hover {
      background-color: #3b3b3b;
      border-radius: 50%;
    }
  }
}

.tabel {
  .tables {
    position: relative;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;

    .isHouse {
      height: 30px !important;
      background-color: $house-type-bgc;
    }

    .table-left {
      position: relative;
      z-index: 20;
      background-color: #ffffff;
      position: sticky;
      left: 0;
      box-shadow: 0 5px 10px rgba(0, 0, 0, 0.05);

      .left-top {
        position: sticky;
        top: 0;
        background: #fff;

        .top-box {
          background-color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          width: $houseWidth;
          height: $tabelHeight;
          border: 1px solid $box-border-color;
          z-index: 30;
        }
      }

      .left-bom {
        height: 100%;
        overflow: hidden;

        &::-webkit-scrollbar {
          display: none;
        }

        /* Firefox */
        & {
          scrollbar-width: none;
        }

        /* IE and Edge */
        & {
          -ms-overflow-style: none;
        }

        .bom-box {
          display: flex;
          align-items: center;
          justify-content: center;
          width: $houseWidth;
          height: $tabelHeight;
          border-right: 1px solid $box-border-color;
          border-bottom: 1px solid $box-border-color;
          border-left: 1px solid $box-border-color;

          .box-date {
            padding: 0 10px;
            overflow: hidden;
            line-height: 16px !important;
          }
        }
      }
    }

    .table-right {
      position: relative;
      overflow: visible;

      .left-srocll-btn {
        position: absolute;
        left: -25px;
        height: 50px;
        width: 50px;
        border-radius: 0 50px 50px 0;
        background-color: #666666;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding: 5px;
        font-size: 20px;
        cursor: pointer;

        &:hover {
          background-color: #3b3b3b;
        }
      }

      .right-srocll-btn {
        position: absolute;
        height: 50px;
        width: 30px;
        border-radius: 50px 0 0 50px;
        background-color: #666666;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding: 5px;
        font-size: 20px;
        cursor: pointer;

        &:hover {
          background-color: #3b3b3b;
        }
      }

      .top-box {
        z-index: 19;
        overflow-y: auto;
        box-shadow: 0 5px 10px rgba(0, 0, 0, 0.05);

        &::-webkit-scrollbar {
          display: none;
        }

        /* Firefox */
        & {
          scrollbar-width: none;
        }

        /* IE and Edge */
        & {
          -ms-overflow-style: none;
        }

        .top-row {
          display: inline-flex;
          background-color: #ffffff;

          .box-grid {
            width: $tabelWidth;
            height: $tabelHeight;
            border-right: 1px solid $box-border-color;
            border-top: 1px solid $box-border-color;
            border-bottom: 1px solid $box-border-color;
            position: relative;

            .grid-box {
              text-align: center;
              color: #000000;
              display: flex;
              flex-direction: column;
              justify-content: center;
              height: 100%;

              .date {
                display: flex;
                align-items: center;
                justify-content: center;

                .holiday {
                  background-color: #da0000;
                  color: #fff;
                  padding: 2px;
                  border-radius: 5px;
                  height: 18px;
                  margin-left: 2px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  font-size: 12px;
                }
              }

              .today {
                background-color: #0094ff;
                color: #fff;
                margin: 0 5px;
                border-radius: 5px;
                display: flex;
                align-items: center;
                justify-content: center;
              }

              .weekend {
                color: #da0000;
              }
            }
          }
        }
      }

      .right-bom {
        overflow: auto;
        position: relative;

        ul {
          list-style: outside none none;
          margin: 0;
          padding: 0;
        }

        .bom-cell {
          display: flex;
          // display: block;
          // height: $tabelHeight;
          // box-sizing: content-box;

          .orderCell {
            border-right: none !important;
          }

          .cell-grid {
            width: $tabelWidth;
            height: $tabelHeight;
            border-right: 1px solid $box-border-color;
            border-bottom: 1px solid $box-border-color;
            position: relative;
            padding: 1px;
            overflow-x: visible;

            .residue {
              display: flex;
              align-items: center;
              justify-content: center;
              margin: auto;
              height: 28px;
            }

            .orderActive {
              border: 2px dashed var(--vi);
            }

            .boxAuto {
              height: 100%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              color: #ffffff;
              display: flex;
              cursor: default;
              padding: 0 3px;
              flex-direction: column;
              justify-content: center;
              position: relative;

              // .order-info {
              //   padding: 0 3px;
              //   display: flex;
              //   flex-direction: column;
              //   justify-content: center;
              //   width: 100%;

              .source_name {
                font-size: 12px;
                color: #2c2c2c;
                display: flex;

                .nights {
                  padding: 0 3px;
                  background-color: #818181;
                  color: #fff;
                  font-size: 12px;
                  border-radius: 2px;
                  margin-left: 1px;
                  transform: scale(0.8);
                  min-width: 18px;
                  text-align: center;
                }
              }

              .tname {
                color: #000000;
                font-size: 12px;
                display: flex;
              }

              // }
              // }
            }

            .isClose {
              position: absolute;
              width: 100%;
              height: 100%;
              background-color: #dcdcff;
              color: #666666;
            }

            .sel-box {
              position: absolute;
              top: 0;
              bottom: 0;
              left: 0;
              right: 0;
              border: 1px solid #0094ff;
            }
          }
        }
      }
    }
  }
}

.isClose {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #dcdcff;
  color: #666666;
}

.clash {
  position: absolute;
  top: 2px;
  right: 2px;
  background-color: #ff6262;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  z-index: 3;
}

.task {
  position: absolute;
  bottom: 0;
  right: 4px;
  color: #da0000;
  display: flex;
  z-index: 3;

  .iconfont {
    margin: 0 4rpx;
  }
}

.highlight {
  z-index: 999;
  -webkit-animation: blink-1 1s both;
  animation: blink-1 1s both;
  animation-iteration-count: 2;

  @-webkit-keyframes blink-1 {
    0%,
    50%,
    100% {
      opacity: 1;
    }

    25%,
    75% {
      opacity: 0;
    }
  }

  @keyframes blink-1 {
    0%,
    50%,
    100% {
      opacity: 1;
    }

    25%,
    75% {
      opacity: 0;
    }
  }
}

.isActiveOrder {
  &::before {
    width: $tabelWidth;
    height: $tabelHeight;
    background-color: #0000002a;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    content: '√';
    color: #fff;
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    z-index: 3;
    left: -1px;
    top: -1px;
  }
}

.isActive {
  &::before {
    width: $tabelWidth;
    height: $tabelHeight;
    border-bottom: 2px solid var(--vi) !important;
    background-color: #00000022;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    content: '√';
    color: var(--vi);
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    z-index: 3;
    left: -1px;
    top: -1px;
  }
}

.mask {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 2;

  .isActive {
    width: 100%;
    height: 100%;
    border-bottom: 2px solid #0094ff;
    background-color: #00000022;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #0094ff;
  }

  .isOrder {
    width: 100%;
    height: 100%;
    border: 2px solid #0094ff;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
  }
}

.expire-tip {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100%;

  .expire-content {
    text-align: center;
    padding: 40px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

    .expire-title {
      font-size: 24px;
      color: #da0000;
      font-weight: bold;
      margin-bottom: 16px;
    }

    .expire-info {
      font-size: 16px;
      color: #333;
      margin-bottom: 12px;
    }

    .expire-renew {
      font-size: 14px;
      color: #666;
    }
  }
}
</style>
